export default "__VITE_ASSET__2ccb161b__"